module.exports = __webpack_public_path__ + "static/media/sparta-logo-w.49fa44d2.webp";